import { render } from "./Menu.vue?vue&type=template&id=d00b11d2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=d00b11d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d00b11d2"

export default script